import React from 'react';
import $ from 'jquery';

const getTradeInCtaModalTemplate = urls => {
  return `
<script type="template" is="gmwc-template" id="tradein-cta-modal">
  <div slot="modal-title" class="modal-title"> </div>
  <button title="Close Trade in modal" slot="modal-close" class="modal-close" onclick="actionDismiss"></button>
  <div slot="modal-content" class="modal-content gmwc-modal-message">
    <p>
      <gm-translate>pe.modal.tradeinappraisal.description</gm-translate>
    </p>
    <a is="gmwc-link" target="_blank" href="${
      urls.tradeInAppraisalUrl
    }" class="gmwc-link">
      <gm-translate>pe.modal.tradeinappraisal.linklabel</gm-translate>
    </a>
  </div>
  <div slot="modal-confirm"></div>
  <div slot="modal-cancel"></div>
</script>`;
};

const getModalCtaTemplate = urls => {
  return `
<script is="gmwc-template" type="template" id="byo-modal-cta-template">
  <button slot="modal-close" class="modal-close" onclick="actionDismiss"></button>
  <div slot="modal-content" class="modal-content">
    <p>
      <gm-translate>pe.othercredits.modal.description</gm-translate>
      <br>
      <a is="gmwc-link" href="" paramhref="${
        urls.gmCardUrl
      }" target="_blank" confirm="true" class="gmwc-link">
        <gm-translate>pe.othercredits.modal.gmcard</gm-translate>
      </a>
      <br>
      <a is="gmwc-link" target="_blank" href="" paramhref="${
        urls.mobilityProgramUrl
      }"
        confirm="true" class="gmwc-link">
        <gm-translate>pe.othercredits.gmmobility</gm-translate>
      </a>
    </p>
  </div>
</script>`;
};

class PaymentEstimatorForm extends React.Component {
  constructor(props) {
    super(props);

    const { urls } = props;

    if (!document.getElementById('tradein-cta-modal')) {
      $(document.body).append(getTradeInCtaModalTemplate(urls));
    }

    if (!document.getElementById('byo-modal-cta-template')) {
      $(document.body).append(getModalCtaTemplate(urls));
    }
  }

  render() {
    return (
      <gmst-pe-financedetailbox
        unlock-other-credits-input="true"
        modal-template="byo-modal-cta-template"
        finance-cta-template="byo-finance-cta-template"
      />
    );
  }
}

export default PaymentEstimatorForm;
